import React, { useState, useEffect } from "react";
import { updateData, getAlert } from "../../../utils/SamuiUtils";

const PoSelectionModal = ({ show, onClose, poList, onConfirm,updateStatus  }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredPoList, setFilteredPoList] = useState([]);
    const [selectedPos, setSelectedPos] = useState([]);

    useEffect(() => {
        if (show) {
            setSearchTerm("");
            setSelectedPos([]);
        }
    }, [show]);

    useEffect(() => {
        setFilteredPoList(
            poList.filter(po =>
                (po.PO_Number?.toLowerCase() ?? "").includes(searchTerm.toLowerCase()) ||
                (po.AP_Name?.toLowerCase() ?? "").includes(searchTerm.toLowerCase()) ||
                (po.DocStatus_Name?.toLowerCase() ?? "").includes(searchTerm.toLowerCase()) // ค้นหาจากสถานะงานด้วย
            )
        );
    }, [searchTerm, poList]);

    const handleSelectPo = (po) => {
        setSelectedPos(prevSelected =>
            prevSelected.some(selected => selected.PO_Number === po.PO_Number)
                ? prevSelected.filter(selected => selected.PO_Number !== po.PO_Number) // ยกเลิกเลือก
                : [...prevSelected, po] // เลือกเพิ่ม
        );
    };

    const handleConfirm = () => {
        if (selectedPos.length > 0) {
            console.debug("selectedPos",selectedPos)
            onConfirm(selectedPos); // ส่งข้อมูล PO ที่เลือกไปให้ `DataTable`
        }
        onClose(); // ปิด Modal หลังจากยืนยัน
    };
    

    // const updateStatus = async (Doc_No) => {
    //     try {
    //         const newStatus = 4;
    //         const values = { Doc_Status: newStatus };
    //         const where = { Doc_No };

    //         console.debug("📌 กำลังอัปเดต PO_H:", values, where);

    //         const res = await updateData("PO_H", values, where);
    //         console.debug("🔍 ผลลัพธ์ updateData:", res);

    //         if (res && res.rowsAffected && res.rowsAffected[0] > 0) {
    //             console.debug("✅ อัปเดตสถานะสำเร็จ! กำลังโหลดข้อมูลใหม่...");
                
    //             await new Promise((resolve) => setTimeout(resolve, 100));

    //             setTimeout(() => {
    //                 window.location.reload();
    //             }, 300);
    //         } else {
    //             throw new Error("⚠️ ไม่สามารถอัปเดตสถานะได้ หรือไม่มีข้อมูลถูกเปลี่ยนแปลง");
    //         }
    //     } catch (error) {
    //         console.error("❌ อัปเดตล้มเหลว:", error);
    //         getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการอัปเดต");
    //     }
    // };

    // const handleConfirmPoSelection = (selectedPos) => {
    //     selectedPos.forEach(po => updateStatus(po.PO_Number));
    // };

    return (
        <>
            <div className={`modal ${show ? "show" : ""}`} style={{ display: show ? "block" : "none" }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">เลือกใบสั่งซื้อเพื่อปิดงาน</h5>
                            <button type="button" className="close" onClick={onClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ค้นหาเลขที่ PO, ผู้ขาย หรือสถานะ"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: "5%" }}>เลือก</th>
                                            <th className="text-center" style={{ width: "15%" }}>เลขที่ PO</th>
                                            <th className="text-center" style={{ width: "35%" }}>ผู้ขาย</th>
                                            <th className="text-center" style={{ width: "20%" }}>สถานะงาน</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredPoList.length > 0 ? (
                                            filteredPoList.map((po, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedPos.some(selected => selected.PO_Number === po.PO_Number)}
                                                            onChange={() => handleSelectPo(po)}
                                                        />
                                                    </td>
                                                    <td className="text-center">{po.PO_Number}</td>
                                                    <td className="text-left">{po.AP_Name || "-"}</td>
                                                    <td className="text-center">{po.DocStatus_Name || "-"}</td> 
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">
                                                    <h5>ไม่พบข้อมูล</h5>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>
                                ปิด
                            </button>
                            <button className="btn btn-primary" onClick={handleConfirm} disabled={selectedPos.length === 0}>
                                ยืนยัน ({selectedPos.length})
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {show && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default PoSelectionModal;
